export const DELIVERY_STATES = Object.freeze({
  PREPARED: "prepared",
  CHANNEL_OPENED: "channel_opened",
  SUBMITTED_CONFIRMED: "submitted_confirmed",
  AWAITING_RESPONSE: "awaiting_response",
  COMPLETED: "completed",
});

export const DELIVERY_CHANNEL_KINDS = Object.freeze({
  EMAIL: "email",
  OFFICIAL_PAGE: "official_page",
});

export function createConfirmedSubmissionRecord({
  company,
  issue,
  channel,
  channelKind,
  reference = "",
  attachmentCount = 0,
  now = new Date(),
}) {
  const sentAt = new Date(now);
  const nextCheck = new Date(sentAt);
  nextCheck.setDate(nextCheck.getDate() + 7);

  return {
    company,
    issue,
    channel,
    channelKind,
    sentAt: sentAt.toLocaleDateString("tr-TR"),
    nextCheck: nextCheck.toLocaleDateString("tr-TR"),
    reference: reference.trim(),
    attachmentCount,
    status: DELIVERY_STATES.AWAITING_RESPONSE,
    submissionConfirmedByUser: true,
  };
}
